<<template>  
  <prop-panel @close="close">
    <p slot="header">{{rs["addTitle"]}}</p>
    
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empId"]}}</span>
          <input ref="empId" type="number" class="form-control" @keyup.enter="onEnter" v-model="empId" >
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["empName"]}}</span>
          <input type="text" class="form-control" readonly='true' v-model="empName" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["deptName"]}}</span>
          <input type="text" class="form-control" readonly='true' v-model="deptName" >
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["xdate"]}}</span>
          <date-input :formater='"yyyy-MM-dd HH:mm:ss"' type="text" class="form-control"  v-model="xdate" />
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["declareName"]}}</span>
          <select v-model="rcType" class="form-control">
            <option v-for='item in dinnerNames' :value="item" >{{item}}</option>
          </select>
        </div>
        <div class="input-group col-md-5" style="margin-left:0">
          <span class="input-group-addon" >{{rs["deduction"]}}</span>
          <input ref="expand" @keyup.enter="rechaegex" type="number" class="form-control" v-model="expand" >
        </div>
    </div>
    <div class="row" style="margin-left:0">
        <div class="input-group col-md-10" style="margin-left:0">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <textarea  v-model="remark"
            rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div slot="footer">
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="rechaegex" type="button" class="btn btn-primary">{{rs["submit"]}}</button>
    </div>
  </prop-panel>
</template>

<<script>
export default {
  created: function() {
    if (!this.config.dinnerNames){
      this.$getData(this.config.url + "GetDinnerName", data=>{
        if (data.rs==1) {
          this.config.dinnerNames = data.dname
          this.dinnerNames = data.dname
          this.rcType=this.dinnerNames[0]
        }
      })
    }
    else {
      this.dinnerNames = this.config.dinnerNames
      this.rcType=this.dinnerNames[0]
    }

    if (!this.xdate) this.xdate=this.$dateNow()
 
  },
  props:["config", "rs", "url"],
  data(){
    return {
      empId: null,
      empName: null,
      deptName:null,
      job:null,
      duty:null,
      amount: 0,
      expand: 0, 
      amax:400, 
      dmax: 400,
      mmax: 400,
      rcDay: 0,
      rcMonth: 0,
      rcType:1,
      remark:null,
      rcNumber:0,
      rcfg:0,
      ws: null,
      vk:null,
      xdate: null,
      dinnerNames:[]
    }
  },
  methods:{
    close: function() {
      this.$emit("close");
    },
    rechaegex(){
      
      if (!this.empName){
        this.$alert("请先加载用户资料！")
        return
      }
      if (this.expand <=0) {
        this.$alert("请输入正确的扣款金额！")
        return
      }
      if (!this.remark || this.$trim(this.remark)==""){
        this.$alert("请先在备注栏输入扣款描述！")
        return
      }
      if (parseFloat(this.expand) + parseFloat(this.amount) > this.amax) {
        this.$alert("扣款金额不能大于余额（" + this.amax + "）, 请更正扣款金额！")
        return
      }

      const sd = {}
      sd.empId=this.empId
      sd.empName = this.empName
      sd.expand = this.expand
      sd.rcType = this.rcType
      sd.remark = this.remark 
      sd.xdate  = this.xdate
      if ( !this.$confirm("是否确认从"+this.empName+"的账户扣除"+(parseFloat(this.expand))+"元？")) return

      this.$save(this.url + "Add", sd, data=>{
        if (data.rs == 1){
          this.empId = null
          this.empName=null
          this.deptName=null
          this.job = null
          this.duty = null
          this.amount = 0
          this.remark = null
          this.$refs.empId.select()
        }
      });
    },
    onEnter(){
      if (!this.empId || this.$trim(this.empId)=="") return
      this.$getData("recharge/GetUser?No=" + this.empId + this.$urlSq(), data=>{
        if (data.rs==1){
          this.rcNumber=data.rcNumber
          this.empName=data.empName
          this.deptName=data.deptName
          this.job = data.job
          this.duty = data.duty
          this.amount = data.amount
          this.amax = data.amax
          this.dmax = data.dmax
          this.mmax = data.mmax
          this.rcDay = data.rcDay
          this.rcMonth = data.rcMonth
          this.rcfg = data.rcfg
          this.$refs.expand.select()
        }
        else if (data.rs==0){
          this.$alert(this.rs["notFound"])
          this.$refs.empId.select()
        }
      })
    }
  }
}
</script>
